import { render, staticRenderFns } from "./survey-report.vue?vue&type=template&id=2e31081f&scoped=true&"
import script from "./survey-report.vue?vue&type=script&lang=js&"
export * from "./survey-report.vue?vue&type=script&lang=js&"
import style0 from "./survey-report.vue?vue&type=style&index=0&id=2e31081f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e31081f",
  null
  
)

export default component.exports